import config from '@/config'
import { i18n } from '@/utils/i18n'
import { PRESIGN_UPLOAD } from '@/config/api'
import { OPENPLATFORM_PRESIGN_UPLOAD, OPENPLATFORM_PRESIGN_UPLOAD_BY_PATH } from '@/config/open-api'
import ajax from '@/utils/ajax'
import openAjax from '@/utils/openAjax'

function getError (option, xhr) {
  const msg = `cannot post ${option.action} ${xhr.status}'`
  const err = new Error(msg)
  err.status = xhr.status
  err.method = 'post'
  err.url = option.action
  return err
}

function getBody (xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }

  try {
    return JSON.parse(text)
  } catch (e) {
    return text
  }
}

export function uploadErrorHandle (result) {
  const errors = result.errors
  if (!errors) return
  if (errors.login_expired || errors.security_check_failed) {
    const redirect = result.redirect || '/sso/logout'
    alert(i18n.t('base.loginFail'), () => {
      window.location.href = redirect
    })
  } else if (errors.validation_errors || errors.external_errors) {
    var errs = errors.validation_errors || errors.external_errors
    return errs[0].error_tr_msg
  } else if (errors.permission_denied) {
    alert(i18n.t('base.noPermission'), () => {
      if (result.redirect) {
        window.location.href = result.redirect
      }
    })
  }
}

/**
 * @param {object} option
 * @param {object} option.param
 * @param {File} option.file
 * @param {function} option.onProgress
 * @param {function} option.onSuccess
 * @param {function} option.onError
 * @param {bool} option.withCredentials
 **/
export const uploadRequests = {}
export let fetchUploadFile = []
export default function upload (option) {
  const requestOption = Object.assign({}, {
    headers: {
      'requesttoken': config.request_token,
      'X-File-Name': encodeURIComponent(option.file.name)
    },
    withCredentials: true
  }, option)
  // pre-check size
  if (option.file.size >= 1024 * 1024 * 1024 * 50) { // 50G
    uploadRequests[option.requestId] = Promise.resolve({
      errors: {
        error_tr_msg: i18n.t('file.size.maxLimit'),
        error_code: 'file size limit'
      }
    })
    return uploadRequests[option.requestId]
  }

  // 开放平台token模式，和普通上传预签名
  var resignReq = null
  console.log(config.isOpenPlatformWithToken)
  if (config.isOpenPlatformWithToken) {
    let param = option.param
    param.name = option.file.name
    param.upload_type = 'api'
    let url = null
    if (config.openConfig.uploadDestFolderPath) {
      url = OPENPLATFORM_PRESIGN_UPLOAD_BY_PATH
      param.target_folder_path = config.openConfig.uploadDestFolderPath
    } else {
      url = OPENPLATFORM_PRESIGN_UPLOAD
      param.parent_id = config.openConfig.uploadDestFolderId
    }

    // 开放平台token模式
    let fetchData = {
      url: url,
      data: param,
      accept_all_errors: option.accept_all_errors || false,
      skipNetworkError: option.skipNetworkError || false
    }
    resignReq = openAjax(fetchData).then(json => {
      json.upload_url = json.presign_url
      return json
    })
  } else {
    // 普通上传预签名
    let fetchData = {
      url: option.presign_url || PRESIGN_UPLOAD,
      data: option.param,
      accept_all_errors: option.accept_all_errors || false,
      skipNetworkError: option.skipNetworkError || false
    }
    resignReq = ajax(fetchData)
  }

  uploadRequests[option.requestId] = resignReq.then(json => {
    if (json) {
      const { upload_url, errors } = json
      if (!upload_url) {
        if (option.accept_all_errors) {
          return json
        } else if (errors) {
          const errs = errors.external_errors || errors.validation_errors
          if (errs) {
            return { errors: errs[0] }
          } else if (errors.permission_denied) {
            return { errors: 'presign_permission_denied' }
          }
          return { errors }
        } else {
          return null
        }
      }

      requestOption.baseUrl = json.upload_url

      return request(requestOption)
    } else {
      delete uploadRequests[option.requestId]
      delete requestWatch[option.requestId]
      return null
    }
  })

  return uploadRequests[option.requestId]
}

export const requestWatch = {}

// xhr2
/* option {
url,
onProgress,
onSuccess,
onError,
filename,
file,
withCredentials,
baseUrl,
headers
} */
function evalFunction (list, ...args) {
  if (list) {
    for (let i = 0; i < list.length; i++) {
      list[i](...args)
    }
  }
}

export function request (option) {
  const xhr = new XMLHttpRequest()
  let listener = {
    onProgress: [],
    onSuccess: [],
    onError: [],
    onAbort: []
  }

  let errorFlag = false

  option.onProgress && listener.onProgress.push(option.onProgress)
  option.onSuccess && listener.onSuccess.push(option.onSuccess)
  option.onError && listener.onError.push(option.onError)
  option.onAbort && listener.onAbort.push(option.onAbort)
  if (xhr.upload) {
    xhr.upload.onprogress = function progress (e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100
      }
      evalFunction(listener.onProgress, e)
    }
  }

  xhr.onerror = function error (e) {
    if (errorFlag) return
    evalFunction(listener.onError, e, option)
    delete uploadRequests[option.requestId]
    delete requestWatch[option.requestId]
    errorFlag = true
  }

  xhr.onabort = function (e) {
    evalFunction(listener.onAbort, e, option)
    delete uploadRequests[option.requestId]
    delete requestWatch[option.requestId]
  }

  let reader = null

  if (('size' in option.file) && option.file.size < 5 * 1024 * 1024) { // folder size may not over 5M
    reader = new FileReader()
    reader.readAsText && reader.readAsText(option.file)
    reader.onerror = function error (e) {
      if (errorFlag) return
      e.errorType = 'readFailed'
      evalFunction(listener.onError, e)
      delete uploadRequests[option.requestId]
      delete requestWatch[option.requestId]
      errorFlag = true
    }
  }

  xhr.onload = function onload () {
    const res = getBody(xhr)
    if (xhr.status < 200 || xhr.status >= 300) {
      const errMsg = getError(option, xhr)
      evalFunction(listener.onError, errMsg, res)
      delete uploadRequests[option.requestId]
      delete requestWatch[option.requestId]
      return
    }
    if (config.isOpenPlatformWithToken) {
      let new_file = getBody(xhr)
      new_file.typed_id = `file_${new_file.id}`
      res.new_file = new_file
      res.success = true
    }
    evalFunction(listener.onSuccess, res, option)
    delete uploadRequests[option.requestId]
    delete requestWatch[option.requestId]
  }

  xhr.open('post', option.baseUrl, true)
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true
  }

  const headers = option.headers || {}

  for (const key in headers) {
    if (headers.hasOwnProperty(key) && headers[key] !== null) {
      xhr.setRequestHeader(key, headers[key])
    }
  }

  if (config.isOpenPlatformWithToken) {
    var formData = new FormData()
    formData.append('openPlatform', option.file)
    if (reader && option.file.size === 0) {
      reader.onload = function () {
        xhr.send(formData)
        requestWatch[option.requestId] = true
      }
    } else {
      xhr.send(formData)
      requestWatch[option.requestId] = true
    }
  } else {
    if (reader && option.file.size === 0) {
      reader.onload = function () {
        xhr.send(option.file)
        requestWatch[option.requestId] = true
      }
    } else {
      xhr.send(option.file)
      requestWatch[option.requestId] = true
    }
  }

  return {
    abort () {
      xhr.abort()
      delete uploadRequests[option.requestId]
      delete requestWatch[option.requestId]
      return option.upload_id
    },

    addListen (obj) {
      Object.keys(obj).forEach(key => {
        listener[key] && listener[key].push(obj[key])
      })
    },

    removeListener (key, fn) {
      if (key) {
        if (listener[key]) {
          listener[key] = listener[key].filter(item => item !== fn)
        }
      } else {
        listener = {}
      }
    }
  }
}
